import { z } from 'zod';
import { TextKey } from '@mews-commander/enums';
import { CommonProcessPaymentFormSchema, ProcessPaymentFormField } from '../ProcessPaymentFormSchema';
import { NEW_CREDIT_CARD_VALUE } from '../../../../constants';
import { createTokenizeCardSchema } from '../TokenizeCardForm/schema';

export enum GatewayPaymentFormField {
    PaymentMethodId = 'paymentMethodId',
    PreAuthorizationId = 'preAuthorizationId',
    ApplyPaymentCardSurcharge = 'applyPaymentCardSurcharge',
}

export const createGatewayPaymentForNewCardSchema = (supportedPaymentCardTypes: string[]) => {
    const tokenizeCardSchema = CommonProcessPaymentFormSchema.merge(
        createTokenizeCardSchema(supportedPaymentCardTypes)
    );
    return tokenizeCardSchema.extend({
        [GatewayPaymentFormField.PaymentMethodId]: z.literal(NEW_CREDIT_CARD_VALUE),
        [GatewayPaymentFormField.ApplyPaymentCardSurcharge]: z.boolean().optional(),
    });
};

export const gatewayPaymentForSelectedCardSchema = CommonProcessPaymentFormSchema.extend({
    [GatewayPaymentFormField.PaymentMethodId]: z.string(),
    [GatewayPaymentFormField.ApplyPaymentCardSurcharge]: z.boolean().optional(),
});

export const createGatewayPaymentForPreauthSchema = (preauthAmount: number) =>
    CommonProcessPaymentFormSchema.extend({
        [GatewayPaymentFormField.PreAuthorizationId]: z.string(),
        [ProcessPaymentFormField.Amount]: z
            .number()
            .gt(0)
            .max(preauthAmount, TextKey.ProcessPaymentMewsPreauthorizationAmountError),
    });

export type GatewayPaymentFieldsForNewCard = z.infer<ReturnType<typeof createGatewayPaymentForNewCardSchema>>;
export type GatewayPaymentFieldsSelectedCard = z.infer<typeof gatewayPaymentForSelectedCardSchema>;
export type GatewayPaymentFieldsForPreauth = z.infer<ReturnType<typeof createGatewayPaymentForPreauthSchema>>;

export type GatewayPaymentFormValues =
    | GatewayPaymentFieldsForNewCard
    | GatewayPaymentFieldsSelectedCard
    | GatewayPaymentFieldsForPreauth;
